import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import FileUpload from '../../components/molecules/FileUpload';
import GroupGochiMenuEditConfirm from './GroupGochiMenuEditConfirm';
import {
  getGroupGochiMenus,
  editGroupGochiMenu,
  addGroupGochiMenuImage
} from '../../actions/GroupGochiMenus';
import { resizeImage, uploadFile, sendLogin } from '../../auth/Auth';
import ValidationText from '../../components/atoms/ValidationText';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  editTable: {
    width: 'auto'
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  },
  priceCalc: {
    margin: '0px 5px',
    color: '#aaa'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      detail: state.gochiMenus.detail,
      groups: state.groups.groups,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGroupGochiMenus,
          editGroupGochiMenu,
          addGroupGochiMenuImage
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openEditProgress', 'updateOpenEditProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isEditSuccess', 'updateIsEditSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('menuId', 'setMenuId', 0),
  withState('menuName', 'setMenuName', ''),
  withState('menuNameError', 'setMenuNameError', ''),
  withState('price', 'setPrice', ''),
  withState('priceError', 'setPriceError', ''),
  withState('priceCalc', 'setPriceCalc', '0 (税抜 0)'),
  withState('description', 'setDescription', ''),
  withState('taxType', 'setTaxType', 'EXTERNAL'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('updatedAt', 'setUpdatedAt', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    defaultPrice: props => () => {
      let includedTaxPrice = 0;
      let excludedTaxPrice = 0;
      // TODO DBから取得
      let tax = 0.1;
      if (props.reducedTaxCheck) {
        tax = 0.08;
      }

      if (props.editInput.price !== '') {
        if (props.editInput.taxType === 'INTERNAL') {
          includedTaxPrice = props.editInput.price;
          excludedTaxPrice =
            props.editInput.price -
            Math.floor((props.editInput.price * tax) / (1 + tax));
        } else {
          includedTaxPrice = Math.floor(props.editInput.price * (1 + tax));
          excludedTaxPrice = props.editInput.price;
        }
      }
      props.setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.setGroupId(this.props.editInput.groupId);
      this.props.setGroupName(this.props.editInput.groupName);
      this.props.setMenuId(this.props.editInput.menuId);
      this.props.setMenuName(this.props.editInput.menuName);
      this.props.setPrice(this.props.editInput.price);
      this.props.setDescription(this.props.editInput.description);
      this.props.setTaxType(this.props.editInput.taxType);
      this.props.setReducedTaxType(this.props.editInput.reducedTaxType);
      if (this.props.editInput.reducedTaxType === 'REDUCED') {
        this.props.setReducedTaxCheck(true);
      }
      this.props.setTags(this.props.editInput.tags);
      this.props.setTagStr(this.props.editInput.tagStr);
      this.props.setPreviewImage(this.props.editInput.image);
      this.props.setUpdatedAt(this.props.editInput.updatedAt);
      this.props.defaultPrice();
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    searchKey,
    editInput,
    openEditConfirm,
    updateOpenEdit,
    updateOpenEditConfirm,
    openEditProgress,
    updateOpenEditProgress,
    loading,
    updateLoading,
    isEditSuccess,
    updateIsEditSuccess,
    resultMessage,
    setResultMessage,
    groupId,
    groupName,
    menuId,
    menuName,
    setMenuName,
    price,
    setPrice,
    priceCalc,
    setPriceCalc,
    description,
    setDescription,
    taxType,
    setTaxType,
    taxTypes,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxType,
    setReducedTaxType,
    tagStr,
    setTagStr,
    tags,
    setTags,
    image,
    setImage,
    previewImage,
    setPreviewImage,
    updatedAt,
    reducedTaxMenuPrefix,
    menuNameError,
    setMenuNameError,
    priceError,
    setPriceError
  }) => {
    const editConfirm = {
      groupName,
      menuName,
      price,
      description,
      taxType,
      reducedTaxCheck,
      tagStr,
      previewImage
    };
    const editParam = {
      groupId,
      menuName,
      price,
      description,
      taxType,
      reducedTaxType,
      tags,
      updatedAt
    };

    const errors = {
      menuNameError,
      priceError
    };
    const validMenuName = () => {
      const value = menuName;
      if (value === '') {
        setMenuNameError('必須項目です。');
        return 1;
      }
      setMenuNameError('');
      setMenuName(value);
      return 0;
    };
    const validPrice = () => {
      const value = price;
      if (value === '') {
        setPriceError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceError('半角数字のみ入力してください。');
        return 1;
      }
      setPriceError('');
      setPrice(value);
      return 0;
    };
    const valid = () => {
      const errorCount = validMenuName() + validPrice();
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const cancelAction = () => updateOpenEdit(false);
    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        updateOpenEditConfirm(true);
      }
    };
    const backAction = () => updateOpenEditConfirm(false);
    const editAction = async () => {
      updateLoading(true);
      updateOpenEditProgress(true);
      const editedMenu = await actions
        .editGroupGochiMenu(menuId, editParam)
        .then(data => checkSession(data));
      if (typeof image !== 'undefined' && image !== null) {
        let imageData = image;
        if (imageData.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
          const { resizeImageFile } = await resizeImage(imageData);
          imageData = resizeImageFile;
        }
        const imagePath = await uploadFile('menu', menuId, imageData, 'public');
        actions
          .addGroupGochiMenuImage(menuId, {
            image: imagePath
          })
          .then(data => checkSession(data));
      }
      if (editedMenu.type === 'EDIT_GROUP_GOCHI_MENU_SUCCESS') {
        updateIsEditSuccess(true);
        actions.getGroupGochiMenus(searchKey).then(data => checkSession(data));
        setResultMessage('編集が完了しました。');
        updateLoading(false);
      } else {
        updateIsEditSuccess(false);
        setResultMessage('編集に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isEditSuccess) {
        updateOpenEdit(false);
        updateOpenEditConfirm(false);
        updateOpenEditProgress(false);
      } else {
        updateOpenEditProgress(false);
      }
    };

    const calcPrice = e => {
      let includedTaxPrice = 0;
      let excludedTaxPrice = 0;

      let latestPrice = price;
      if (e.target.id === 'price') {
        latestPrice = e.target.value;
      }

      let latestTaxType = taxType;
      if (e.target.name === 'taxType') {
        latestTaxType = e.target.value;
      }

      // TODO DBから取得
      let tax = 0.1;
      if (
        (e.target.id !== 'reducedTax' && reducedTaxCheck) ||
        (e.target.id === 'reducedTax' && e.target.checked)
      ) {
        // TODO DBから取得
        tax = 0.08;
      }

      if (latestPrice !== '') {
        if (latestTaxType === 'INTERNAL') {
          includedTaxPrice = latestPrice;
          excludedTaxPrice =
            latestPrice - Math.floor((latestPrice * tax) / (1 + tax));
        } else {
          includedTaxPrice = Math.floor(latestPrice * (1 + tax));
          excludedTaxPrice = latestPrice;
        }
      }

      setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
    };
    const splitTagStr = str => {
      if (str === '') {
        setTags(null);
      } else {
        setTags(
          str.split(/\s+/).map(t => {
            return { tagName: t };
          })
        );
      }
    };
    const convertReducedTax = checked => {
      if (checked) {
        setReducedTaxType('REDUCED');
      } else {
        setReducedTaxType('UNREDUCED');
      }
    };
    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">グループメニュー編集</Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.editTable}>
            <TableRow>
              <TableCell>
                <RequiredButton />
              </TableCell>
              <TableCell>
                <TextField
                  required
                  label="グループ名"
                  defaultValue={editInput.groupName}
                  className={classes.textField}
                  margin="normal"
                  InputProps={{
                    readOnly: true
                  }}
                  variant="filled"
                />
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell>
                <RequiredButton />
              </TableCell>
              <TableCell>
                <TextField
                  required
                  label="メニュー名"
                  defaultValue={editInput.menuName}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setMenuName(e.target.value);
                  }}
                  onBlur={validMenuName}
                />
                <ValidationText message={errors.menuNameError} />
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell>
                <RequiredButton />
              </TableCell>
              <TableCell>
                <TextField
                  id="price"
                  required
                  label="価格"
                  defaultValue={editInput.price}
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setPrice(e.target.value);
                    calcPrice(e);
                  }}
                  onBlur={validPrice}
                />
                <ValidationText message={errors.priceError} />
                <div className={classes.priceCalc}>{priceCalc}</div>
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell>
                <RequiredButton />
              </TableCell>
              <TableCell>
                <div>
                  <TextField
                    id="taxType"
                    name="taxType"
                    select
                    label="税区分・寄付"
                    className={classes.textField}
                    margin="normal"
                    value={taxType}
                    onChange={e => {
                      setTaxType(e.target.value);
                      calcPrice(e);
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                  >
                    {taxTypes.map(group => {
                      return (
                        <MenuItem key={group.id} value={group.id}>
                          {group.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </div>
                <FormControlLabel
                  control={
                    <Checkbox color="primary" checked={reducedTaxCheck} />
                  }
                  label="軽減税率対象"
                  onChange={e => {
                    setReducedTaxCheck(e.target.checked);
                    convertReducedTax(e.target.checked);
                    calcPrice(e);
                  }}
                />
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell>
                <AnyButton />
              </TableCell>
              <TableCell>
                <TextField
                  label="説明"
                  multiline
                  rows="4"
                  defaultValue={editInput.description}
                  className={classes.textFieldLong}
                  margin="normal"
                  onChange={e => {
                    setDescription(e.target.value);
                  }}
                />
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell>
                <AnyButton />
              </TableCell>
              <TableCell>
                <TextField
                  label="タグ"
                  defaultValue={editInput.tagStr}
                  className={classes.textFieldLong}
                  margin="normal"
                  onChange={e => {
                    setTagStr(e.target.value);
                    splitTagStr(e.target.value);
                  }}
                />
              </TableCell>
              <TableCell>
                #おすすめ #おふくろの味 #学生に ＃ガッツリ
                などメニューの特徴を表すタグを記載できます。
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellBorderNone}>
                <AnyButton />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone}>
                <FileUpload
                  label="image"
                  file={image}
                  setFile={setImage}
                  previewImage={previewImage}
                  setPreviewImage={setPreviewImage}
                />
              </TableCell>
              <TableCell className={classes.tableCellBorderNone} />
            </TableRow>
          </Table>
        </Paper>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openEditConfirm}>
          <GroupGochiMenuEditConfirm
            backAction={backAction}
            editAction={editAction}
            editConfirm={editConfirm}
            reducedTaxMenuPrefix={reducedTaxMenuPrefix}
            openEditProgress={openEditProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
